window.submoduleBrunchNames = {
  [OPUtility.eSubmoduleNames.ESN_OP_WRAPPER_SERVICE]: 'new_ui_2.9',
  [OPUtility.eSubmoduleNames.ESN_GAME_ENGINE]: 'main2_new_ui_2.9',
  [OPUtility.eSubmoduleNames.ESN_OP_PRELOADER]: 'master'
}
